import React from 'react'
import { Container } from './styles'

export interface LabelRowProps {
  period: string | number
  quantity?: number
  isFilled: boolean
}

export const LabelRow = ({ period, quantity, isFilled }: LabelRowProps): JSX.Element => {
  return (
    <Container isFilled={isFilled}>
      <p>
        {period} {typeof quantity === 'number' && <span>({quantity})</span>}
      </p>
    </Container>
  )
}
